import * as LucideIcons from 'lucide-react';

// Independent CounterRow component
export function CounterRow({
    label,
    value,
    onChange,
    min = 0,
    max = Infinity
}: {
    label: string;
    value: number;
    onChange: (newValue: number) => void;
    min?: number;
    max?: number;
}) {
    const handleDecrement = () => {
        const newValue = Math.max(min, value - 1);
        if (newValue !== value && onChange) {
            onChange(newValue);
        }
    };

    const handleIncrement = () => {
        const newValue = Math.min(max, value + 1);
        if (newValue !== value && onChange) {
            onChange(newValue);
        }
    };

    const MinusIcon = LucideIcons.Minus;
    const PlusIcon = LucideIcons.Plus;

    return (
        <div className="flex items-center justify-between py-4 border-b border-black last:border-b-0">
            <span className="text-gray-900 text-base font-normal">{label}</span>
            <div className="flex items-center gap-4">
                <button
                    type="button"
                    onClick={handleDecrement}
                    disabled={value <= min}
                    className="w-8 h-8 rounded-full border border-gray-300 flex items-center justify-center hover:border-gray-900 disabled:opacity-30 disabled:cursor-not-allowed disabled:hover:border-gray-300 transition-colors"
                    aria-label={`Decrease ${label}`}
                >
                    <MinusIcon size={16} aria-hidden="true" />
                </button>

                <span className="text-gray-900 text-base font-normal min-w-[20px] text-center">
                    {value}
                </span>

                <button
                    type="button"
                    onClick={handleIncrement}
                    disabled={value >= max}
                    className="w-8 h-8 rounded-full border border-gray-300 flex items-center justify-center hover:border-gray-900 disabled:opacity-30 disabled:cursor-not-allowed disabled:hover:border-gray-300 transition-colors"
                    aria-label={`Increase ${label}`}
                >
                    <PlusIcon size={16} aria-hidden="true" />
                </button>
            </div>
        </div>
    );
}
